<template>
  <div class="study_profile_modal__wrapper">
    <div class="study_profile_modal__container">
      <div class="modal__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">{{ $t("navigations.edit study") }}</h4>
        <div
          class="tooltip-wrapper pointer"
         
          style="float: right; cursor: pointer"
        >
          <i class="fa fa-times" @click.prevent="closeModal"></i>
           <span class="custom-tooltip closetooltipposition">Close</span>
        </div>
      </div>
      <div class="ibox-content p-3">
        <div class="form-group row mb-0">
          <div class="col-lg-4 mb-1">
            <label class="col-form-label"
              >{{$t("navigations.study id")}}<sup><i class="fa fa-asterisk required"></i></sup
            ></label>
            <input
              type="text"
              class="form-control"
              v-model="values.studyRef"
              maxlength="1000"
              readonly
            />
            <span class="errormsg" v-if="errors[1] == false">{{
              $t("navigations.please enter a study id")
            }}</span>
          </div>
          <div class="col-lg-4 mb-1">
            <label class="col-form-label"
              >{{$t("navigations.study name")}}<sup><i class="fa fa-asterisk required"></i></sup
            ></label>
            <input
              type="text"
              class="form-control"
              v-model="values.studyName"
              maxlength="1000"
            />
            <span class="errormsg" v-if="errors[0] == false">{{
              $t("navigations.please enter a study name")
            }}</span>
          </div>
          <div class="col-lg-4 mb-1">
            <label class="col-form-label">
              {{ $t("navigations.sponsor") }}</label
            >
            <input
              type="email"
              class="form-control"
              v-model="values.sponsor"
              maxlength="1000"
            />
          </div>
          <div class="col-lg-4 mb-1">
            <label class="col-form-label">{{
              $t("navigations.study type")
            }}</label>
            <select class="form-select" v-model="selectedStudyType">
              <option value="" disabled selected>
                {{ $t("navigations.select") }}
              </option>
              <template v-for="classification in classficationList">
                <template
                  v-if="
                    classification.classifier === 'Study Design (Allocation)'
                  "
                >
                  <option
                    v-for="studyType in classification.classifications"
                    :key="studyType"
                  >
                    {{ studyType }}
                  </option>
                </template>
              </template>
            </select>
          </div>
          <div class="col-lg-4 mb-1">
            <label class="col-form-label">{{
              $t("navigations['estimated no.of subjects']")
            }}</label>
            <input
              type="text"
              class="form-control"
              maxlength="1000"
              v-model="values.numberOfPatient"
              @change.prevent="numberonlyvalidation('numberOfPatient')"
            />
            <span
              class="errormsg"
              v-if="numerrors['numberOfPatient'] == false"
              >{{ $t("navigations.please enter a number") }}</span
            >
          </div>
          <div class="col-lg-4 mb-1">
            <label class="col-form-label">{{
              $t("navigations['estimated no.of sites']")
            }}</label>
            <input
              type="text"
              class="form-control"
              maxlength="1000"
              v-model="values.numberOfSite"
              @change.prevent="numberonlyvalidation('numberOfSite')"
            />
            <span class="errormsg" v-if="numerrors['numberOfSite'] == false">{{
              $t("navigations.please enter a number")
            }}</span>
          </div>
          <div class="col-lg-4 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.allocation") }}
            </label>
            <select class="form-select" v-model="allocation">
              <option value="" disabled selected>
                {{ $t("navigations.select") }}
              </option>

              <template v-for="classification in classficationList">
                <template v-if="classification.classifier === 'Allocation'">
                  <option
                    v-for="allocation in classification.classifications"
                    :key="allocation"
                  >
                    {{ allocation }}
                  </option>
                </template>
              </template>
            </select>
          </div>
          <div class="col-lg-4 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.intervention model") }}
            </label>
            <select class="form-select" v-model="intervention">
              <option value="" disabled selected>
                {{ $t("navigations.select") }}
              </option>
              <template v-for="classification in classficationList">
                <template
                  v-if="
                    classification.classifier ===
                    'Nature of Interventions or Exposures'
                  "
                >
                  <option
                    v-for="intervention in classification.classifications"
                    :key="intervention"
                  >
                    {{ intervention }}
                  </option>
                </template>
              </template>
            </select>
          </div>
          <div class="col-lg-4 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.masking") }}
            </label>
            <select class="form-select" v-model="masking">
              <option value="" disabled selected>
                {{ $t("navigations.select") }}
              </option>
              <template v-for="classification in classficationList">
                <template v-if="classification.classifier === 'Masking'">
                  <option
                    v-for="masking in classification.classifications"
                    :key="masking"
                  >
                    {{ masking }}
                  </option>
                </template>
              </template>
            </select>
          </div>
          <div class="col-lg-4 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.primary purpose") }}
            </label>
            <select class="form-select" v-model="purpose">
              <option value="" disabled selected>
                {{ $t("navigations.select") }}
              </option>
              <template v-for="classification in classficationList">
                <template
                  v-if="classification.classifier === 'Primary Purpose'"
                >
                  <option
                    v-for="purpose in classification.classifications"
                    :key="purpose"
                  >
                    {{ purpose }}
                  </option>
                </template>
              </template>
            </select>
          </div>
          <div class="col-lg-4 mb-1">
            <label class="col-form-label">{{
              $t("navigations.official title")
            }}</label>
            <input
              type="text"
              class="form-control"
              maxlength="1000"
              v-model="title"
            />
          </div>

          <div class="col-lg-4 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.study notes") }}
            </label>
            <input
              type="test"
              class="form-control"
              v-model="values.studyNotes"
              maxlength="1000"
            />
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.pre-visit") }}
            </label>
            <input
              type="text"
              class="form-control"
              maxlength="4"
              v-model="values.preVisit"
              @change.prevent="numberonlyvalidation('preVisit')"
            />
            <span class="errormsg" v-if="numerrors['preVisit'] == false">{{
              $t("navigations.Please enter a number")
            }}</span>
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label">{{
              $t("navigations.post-visit")
            }}</label>
            <input
              type="text"
              class="form-control"
              maxlength="4"
              v-model="values.postVisit"
              @change.prevent="numberonlyvalidation('postVisit')"
            />
            <span class="errormsg" v-if="numerrors['postVisit'] == false">{{
              $t("navigations.Please enter a number")
            }}</span>
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.duration (year)") }}
            </label>
            <input
              type="text"
              class="form-control"
              maxlength="1000"
              v-model="values.duration"
              @change.prevent="numberonlyvalidation('duration')"
            />
            <span class="errormsg" v-if="numerrors['duration'] == false">{{
              $t("navigations.please enter a number")
            }}</span>
          </div>

          <div class="col-lg-3 mb-1">
            <label class="col-form-label">
              {{ $t("navigations.status") }}</label
            >
            <select class="form-select" name="account" v-model="values.status">
              <option>Archived</option>
              <option>Closed</option>
              <option>New</option>
              <option>Open</option>
            </select>
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label"> Version</label>
            <input
                type="text"
                class="form-control"
                v-model="values.currentVersion"
                readonly
                placeholder="Enter new version"
            />
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label me-2 mb-0">Require Re-Consent</label>
            <input type="checkbox" v-model="currentVersionDetails.reqReConsent" disabled />
          </div>
 
          <div class="col-lg-4 mb-1">
            <label class="col-form-label">Regulatory Ref</label>
            <input
              type="text"
              class="form-control"
              v-model="currentVersionDetails.regulatoryRef" 
              readonly
            />
          </div>
 
          <div class="col-lg-6 mb-1">
            <label class="col-form-label">Change Type</label>
            <input
              type="text"
              class="form-control"
              v-model="currentVersionDetails.changeType"
              readonly
            />
          </div>
 
          <div class="col-lg-12 mb-2">
            <label class="col-form-label">Reason for Change</label>
            <textarea
              class="form-control"
              rows="3"
              v-model="currentVersionDetails.reasonForChange"
              readonly
              placeholder="Describe reason for version change"
            ></textarea>
          </div>
          <!-- <div class="col-lg-6 mb-1">
                        </div> -->
          <div class="col-lg-4 mt-2 d-flex">
            <div>
              <div>
                <label class="mr-2 mb-0">{{ $t("navigations.active") }}</label>
                <input type="checkbox" v-model="values.active" />
              </div>
            </div>
          </div>
             <div class="col-lg-4 mt-2 d-flex">
            <div>
              <div>
                <label class="mr-2 mb-0">{{ $t("navigations.isArmSpecific") }}</label>
                <input type="checkbox" v-model="currentVersionDetails.isArmSpecific" />
              </div>
            </div>
          </div>
          <div class="col-lg-12 mt-1 d-flex justify-content-lg-end">
            <button
              class="cancel_btn py-1 px-4 mx-3"
              type="button"
              @click.prevent="clear"
            >
              {{ $t("navigations.clear") }}
            </button>
            <button
              class="save_btn py-1 px-4"
              type="submit"
              @click.prevent="addStudy"
            >
              {{ $t("navigations.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./EditStudyPopUp.js"></script>
<style scoped>
.study_profile_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}

.study_profile_modal__container {
  position: fixed;
  width: min(50%, 90%);
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
}
.modal__title {
  background-color: var(--pop-up-background);
  color: #fff;
}
.cancel_btn {
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
}
</style>